import { defineComponent as p, createBlock as m, openBlock as r, unref as e, normalizeClass as u, withCtx as f, createVNode as n, createElementBlock as b, createCommentVNode as g, createElementVNode as s, createTextVNode as a } from "vue";
import { ScalarIconPencil as _, ScalarIconImage as C } from "@scalar/icons";
import { NodeViewWrapper as y } from "@tiptap/vue-3";
import { usePageRenameModal as k } from "../../../events/index.js";
import { useEditorStore as N } from "../../../store.js";
import { useIsEditable as h } from "../../../../hooks/useIsEditable.js";
import x from "./ScalarPageTitle.vue.js";
const E = {
  key: 0,
  class: "edit-hint-container"
}, P = {
  class: "edit-hint-button",
  type: "button"
}, V = {
  class: "edit-hint-button",
  type: "button"
}, D = /* @__PURE__ */ p({
  __name: "CustomPageTitle",
  props: {
    decorations: {},
    selected: { type: Boolean },
    updateAttributes: { type: Function },
    deleteNode: { type: Function },
    node: {},
    view: {},
    getPos: { type: Function },
    innerDecorations: {},
    editor: {},
    extension: {},
    HTMLAttributes: {}
  },
  setup(l) {
    const d = l, { state: i } = N(), { handleClick: c } = k(), { isEditable: o } = h(d.editor);
    return (B, t) => (r(), m(e(y), {
      class: u(["guide-node-component", e(o) && "page-title-node"]),
      contenteditable: "false",
      onClick: t[0] || (t[0] = () => e(o) ? e(c)() : null)
    }, {
      default: f(() => [
        n(x, {
          description: e(i).pageDescription,
          title: e(i).pageTitle
        }, null, 8, ["description", "title"]),
        e(o) ? (r(), b("div", E, [
          s("button", P, [
            n(e(_)),
            t[1] || (t[1] = a(" Heading/Subheading "))
          ]),
          s("button", V, [
            n(e(C)),
            t[2] || (t[2] = a(" Cover Photo "))
          ])
        ])) : g("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
export {
  D as default
};
